const supportedLanguages = [
	{
		name: 'English (United States)',
		iso3: 'USA',
	},
	{
		name: 'English (Australia)',
		iso3: 'AUS',
	},
	{
		name: 'English (Singapore)',
		iso3: 'SGP',
	},
	{
		name: 'slovenčina (Slovenská republika)',
		iso3: 'SVK',
	},
	{
		name: 'Türkçe (Türkiye)',
		iso3: 'TUR',
	},
	{
		name: 'русский (Россия)',
		iso3: 'RUS',
	},
	{
		name: 'svenska (Sverige)',
		iso3: 'SWE',
	},
	{
		name: 'português (Portugal)',
		iso3: 'PRT',
	},
	{
		name: 'italiano (Italia)',
		iso3: 'ITA',
	},
	{
		name: 'română (România)',
		iso3: 'ROU',
	},
	{
		name: 'hrvatski (Hrvatska)',
		iso3: 'HRV',
	},
	{
		name: 'magyar (Magyarország)',
		iso3: 'HUN',
	},
	{
		name: 'français (France)',
		iso3: 'FRA',
	},
	{
		name: 'français (Canada)',
		iso3: 'CAN',
	},
	{
		name: 'français (Belgique)',
		iso3: 'BEL',
	},
	{
		name: 'español (España)',
		iso3: 'ESP',
	},
	{
		name: 'suomi (Suomi)',
		iso3: 'FIN',
	},
	{
		name: 'dansk (Danmark)',
		iso3: 'DNK',
	},
	{
		name: 'čeština (Česká republika)',
		iso3: 'CZE',
	},
	{
		name: 'Deutsch (Deutschland)',
		iso3: 'DEU',
	},
	{
		name: '中文(中华人民共和国)',
		iso3: 'CHN',
	},
	{
		name: 'polski (Polska)',
		iso3: 'POL',
	},
	{
		name: 'nynorsk (Noreg)',
		iso3: 'NOR',
	},
	{
		name: 'Nederlands (Nederland)',
		iso3: 'NLD',
	},
	{
		name: 'Bahasa Melayu (Malaysia)',
		iso3: 'NLD',
	},
	{
		name: '한국어(대한민국)',
		iso3: 'KOR',
	},
	{
		name: 'English (United Kingdom)',
		iso3: 'GBR',
	},
	{
		name: '日本語 (日本)',
		iso3: 'JPN',
	},
];

export default supportedLanguages;